




















import './KisweButtonDescriptive.scss'
import { defineComponent } from '@vue/composition-api'
import KisweButton from '../KisweButton'
import KisweRibbon from '../../KisweRibbon'

export default defineComponent({
  name: 'KisweButtonDescriptive',
  components: {
    KisweButton,
    KisweRibbon
  },
  inheritAttrs: false,
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    showBetaRibbon: {
      type: Boolean,
      required: false,
      default: false
    },
    theme: {
      type: String,
      required: false,
      default: 'default'
    }
  },
  emits: {
    click () { return true },
    mouseup () { return true },
    mousedown () { return true }
  },
  methods: {
    click () {
      this.$emit('click')
    },
    mouseup () {
      this.$emit('mouseup')
    },
    mousedown () {
      this.$emit('mousedown')
    }
  }
})
